import React from 'react'
import { editAdminProfileInfo } from '../../Apis/profile'; 
import Form from './Form'

export default function EditAccountSettings() {
    // onsubmit
    const onSubmit = async (e, data) => {
        e.preventDefault();
        //to send request
        console.log(data)
        return await editAdminProfileInfo(data).then(res => {
            console.log(res.data)
            return 'done';          
        }).catch(err => {
            console.error(err.response);
            return err.response.data.errors;
        }) 
    };

    return (
        <Form onSubmit={onSubmit}></Form>
    )
}
